var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#272747",
    d: "M8 10.625c2.171 0 3.938-2.159 3.938-4.813C11.938 3.16 10.171 1 8 1c-1.07 0-2.071.514-2.816 1.446-.724.904-1.121 2.099-1.121 3.367 0 2.653 1.765 4.812 3.937 4.812m0-8.75c1.688 0 3.063 1.766 3.063 3.937C11.063 7.984 9.688 9.75 8 9.75S4.938 7.984 4.938 5.813 6.312 1.875 8 1.875m3.063 7.875a.437.437 0 1 0 0 .876 3.067 3.067 0 0 1 3.063 3.063.44.44 0 0 1-.438.438H2.313a.44.44 0 0 1-.438-.438 3.067 3.067 0 0 1 3.063-3.063.437.437 0 1 0 0-.876A3.94 3.94 0 0 0 1 13.688C1 14.411 1.589 15 2.313 15h11.375c.723 0 1.312-.589 1.312-1.312a3.943 3.943 0 0 0-3.937-3.938"
  })));
};
export default SvgUser;